import { forwardRef } from "react";
const SvgOpen = ({
  title,
  titleId,
  ...props
}, ref) => <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<g clipPath="url(#clip0_2781_599)"><path d="M15 12V13C15 14.1046 14.1046 15 13 15H3C1.89543 15 1 14.1046 1 13V3C1 1.89543 1.89543 1 3 1H4M14 2H9M14 2V7M14 2L7 9" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" /></g><defs><clipPath id="clip0_2781_599"><rect width={16} height={16} fill="white" /></clipPath></defs></svg>;
const ForwardRef = forwardRef(SvgOpen);
export default ForwardRef;